import { inject } from '@angular/core';
import { MetaDefinition } from '@angular/platform-browser';
import { ResolveFn } from '@angular/router';
import { getMetaImageTags, noIndexMetaTag } from '../../lib/meta-helpers';
import { TenantProfileResolve } from '../../view-gallery/resolves/tenant-profile.resolve';

export const noIndextenantProfilePageMetaResolver: ResolveFn<{ title: string; tags: MetaDefinition[] }> = () => {
  const re = inject(TenantProfileResolve);

  return re.resolve().then(tenant => {
    const title = tenant ? tenant.name : 'Picflow Profile';
    return {
      title,
      tags: [...getMetaImageTags(''), noIndexMetaTag],
    };
  });
};
